export const LOGO_URL = `${process.env.PUBLIC_URL || ""}/logo.jpeg`;

// White "spec-plate" wrapper so the white-background logo reads cleanly on dark navy surfaces
export const BrandLogo = ({ className = "h-9" }) => (
  <div className="bg-white p-1.5 border border-border inline-flex items-center justify-center shrink-0" data-testid="brand-logo">
    <img src={LOGO_URL} alt="Country Courier" className={`${className} w-auto object-contain`} />
  </div>
);

export default BrandLogo;
